import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import ThemeToggle from '../ThemeToggle/ThemeToggle';
import { socialLinks } from '../../Utils/data';
import './Header.css';

const NAV = [
  { label: 'meet damilare', path: '/'        },
  { label: 'my work',       path: '/work'    },
  { label: 'about',         path: '/about'   },
  { label: 'blog',          path: '/blog'    },
  { label: 'contact me',    path: '/contact' },
];

/* Two-letter marks, as in the frame. Short enough to read as a set. */
const SOCIAL = [
  { label: 'gh', href: socialLinks.github,   title: 'GitHub'   },
  { label: 'tw', href: socialLinks.twitter,  title: 'Twitter'  },
  { label: 'in', href: socialLinks.linkedin, title: 'LinkedIn' },
];

function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => { setOpen(false); }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      <header className="nav">
        <div className="nav__inner shell">
          <NavLink to="/" className="nav__mark" aria-label="Damilare Oyedeji, home">
            Damilare
          </NavLink>

          <nav className="nav__links" aria-label="Primary">
            {NAV.map(({ label, path }) => (
              <NavLink
                key={path}
                to={path}
                end={path === '/'}
                className={({ isActive }) =>
                  `nav__link${isActive ? ' nav__link--on' : ''}`
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>

          <div className="nav__tail">
            <ul className="nav__social">
              {SOCIAL.map(({ label, href, title }) => (
                <li key={label}>
                  <a href={href} target="_blank" rel="noreferrer" title={title}>
                    {label}
                    <span className="sr-only"> ({title})</span>
                  </a>
                </li>
              ))}
            </ul>

            <ThemeToggle />

            <button
              type="button"
              className="nav__burger"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? 'Close menu' : 'Open menu'}
              aria-expanded={open}
            >
              {open
                ? <X size={20} strokeWidth={2} aria-hidden="true" />
                : <Menu size={20} strokeWidth={2} aria-hidden="true" />}
            </button>
          </div>
        </div>
      </header>

      {open && (
        <div className="sheet">
          <nav className="sheet__links" aria-label="Primary, mobile">
            {NAV.map(({ label, path }, i) => (
              <NavLink
                key={path}
                to={path}
                end={path === '/'}
                className={({ isActive }) =>
                  `sheet__link${isActive ? ' sheet__link--on' : ''}`
                }
                style={{ '--i': i }}
              >
                {label}
              </NavLink>
            ))}
          </nav>

          <ul className="sheet__social">
            {SOCIAL.map(({ label, href, title }) => (
              <li key={label}>
                <a href={href} target="_blank" rel="noreferrer">{title}</a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}

export default Header;
